// The guided tour of Quality Docs, the policy library, for the move from
// PDF attachments to policies read in the app.
//
// Steps point at the library page via [data-tour] attributes. The viewer's
// Overview | Full version switch lives inside the reading modal, which is not
// open while the tour runs, so that step is written to read standalone and the
// engine shows it centred (its documented fallback for a missing target).
//
// The engine (shared/FeatureTour.jsx) and the show-once record
// (hooks/useFeatureTour.js) are generic; only this file knows about policies.

export const QMS_DOCS_TOUR_ID = 'quality-docs';

export const qmsDocsTourSteps = [
  {
    title: 'Company policies, in the app',
    body: [
      'Policies and procedures now open here as pages rather than PDFs. This short tour shows you how to read one, what the Overview is, and how acknowledging works.',
      'Use Next to walk through, or Skip if you would rather explore. Either way it will not pop up again.',
    ],
  },
  {
    title: 'Your reading progress',
    target: '[data-tour="qms-progress"]',
    body: [
      'Some documents must be read and acknowledged by everyone. This card shows how many you still have to do, and "Jump to unread" lists them.',
    ],
  },
  {
    title: 'Read a document',
    target: '[data-tour="qms-read"]',
    body: [
      'Read opens the document in the app. Where a policy has been imported from Word or written here, you will see it as a page with the version, owner and review date at the top.',
      'Older documents that are still PDFs open in the PDF viewer, as before.',
    ],
  },
  {
    title: 'Overview or full version',
    body: [
      'Many policies have two forms. The Overview is a short plain-English summary: what the policy is for, who it applies to, what you need to do, and any figures such as amounts or notice periods. The Full version is the controlled wording.',
      'The switch is at the top of the document. Start with the Overview; read the Full version when you need the detail, or when you are acknowledging.',
    ],
  },
  {
    title: 'Read and acknowledge',
    target: '[data-tour="qms-read-acknowledge"]',
    body: [
      'For a document that requires acknowledgement, read the Full version to the end. Reaching the bottom unlocks the confirmation and records that you have read it.',
      'Reading only the Overview does not count: what you are agreeing to is the full wording.',
      'When a new version of one of these goes live, it also arrives in your Actions. Reading it from there works the same way, and the item clears once you have acknowledged.',
    ],
  },
  {
    title: 'Printing',
    body: [
      'Print / PDF at the top of a document gives a clean copy of the full version with its version number in the footer. The live version in the app is always the controlled one.',
    ],
  },
];
